import { render, staticRenderFns } from "./SingleZoneSmall.vue?vue&type=template&id=04956223&scoped=true&"
import script from "./SingleZoneSmall.vue?vue&type=script&lang=js&"
export * from "./SingleZoneSmall.vue?vue&type=script&lang=js&"
import style0 from "./SingleZoneSmall.vue?vue&type=style&index=0&id=04956223&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04956223",
  null
  
)

export default component.exports